module.exports = __webpack_public_path__ + "static/media/material-symbols_manage-search-rounded.80295853.svg";